import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_IMPRESSIONS_LIST = 'GET_IMPRESSIONS_LIST';
export const GET_IMPRESSIONS_LIST_SUCCESS = 'GET_IMPRESSIONS_LIST_SUCCESS';
export const GET_IMPRESSIONS_LIST_FAILURE = 'GET_IMPRESSIONS_LIST_FAILURE';

// Action Creators
export const getImpressionsList = () => ({
  type: GET_IMPRESSIONS_LIST,
});

export const getImpressionsListSuccess = (users) => ({
  type: GET_IMPRESSIONS_LIST_SUCCESS,
  payload: users,
});

export const getImpressionsListFailure = (error) => ({
  type: GET_IMPRESSIONS_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const getImpressionsListCallApi = (external) => {
  return async (dispatch) => {
    dispatch(getImpressionsList());
    try {
      const response = await getMethodWithToken(url.impressions);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getImpressionsListSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getImpressionsListFailure(error?.message));
    }
  };
};
